import {Component, Input} from '@angular/core';
import {
  Technology,
  technologyToColor,
  technologyToLabel,
  technologyToNeutralIcon
} from '../../model/general/Technology';

@Component({
  selector: 'digires-tech-icon',
  templateUrl: './tech-icon.component.html',
  styleUrls: ['./tech-icon.component.scss']
})
export class TechIconComponent {

  public readonly technologyToTooltip = technologyToLabel;
  public readonly technologyToIcon = technologyToNeutralIcon;
  public readonly technologyToColor = technologyToColor;

  @Input() technology: Technology;
  @Input() leading: boolean;
  @Input() size: 'small' | 'big' | 'medium' = 'small';
  @Input() defaultIconColor: string;
  @Input() defaultBackgroundColor: string;
  @Input() disabled: boolean;
  @Input() darken: boolean;
  @Input() tooltip: string;

}
